var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_BILLING_ADDRESS } from '../actions/billingAddress';
var initialStore = {
    billingAddress: undefined
};
export default function billingAddress(state, _a) {
    if (state === void 0) { state = initialStore; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case SET_BILLING_ADDRESS:
            return __assign(__assign({}, state), { billingAddress: payload });
        default:
            return state;
    }
}
